import { useState, useCallback, useMemo } from "react";
import { type ComponentHash, type UniformInputsProps } from "./type";

export const useUniformInputs = (componentHash: ComponentHash): UniformInputsProps => {
  const [checked, setChecked] = useState(componentHash.checked);
  const [inputValues, setInputValues] = useState({
    uniformProvidingConditions: "",
    ...componentHash.inputValues,
  });

  const parentCheckboxId = `work_requirement_welfares_${componentHash.value}`;

  // フォームの値をリセットする関数
  const clearFormValues = useCallback(() => {
    setInputValues({
      uniformProvidingConditions: "",
    });
  }, []);

  // チェックボックスの変更をハンドルする関数
  const handleChangeCheckbox = useCallback(
    (newValue: boolean) => {
      if (!newValue) {
        const hasInput = inputValues.uniformProvidingConditions !== "";
        if (hasInput) {
          const userConfirmed = window.confirm(
            "チェックを外すと入力内容がリセットされます。本当にチェックを外しますか？",
          );
          if (!userConfirmed) {
            return;
          }
        }
        clearFormValues();
      }
      setChecked(newValue);
    },
    [clearFormValues, inputValues],
  );

  // 入力値の変更をハンドルする関数
  const handleInputChange = useCallback((field: string, value: string) => {
    setInputValues((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }, []);
  const uniformInputsData = useMemo<UniformInputsProps>(() => {
    const { name, value, formNames, errors } = componentHash;

    return {
      text: name,
      value,
      formNames,
      errors,
      inputValues,
      hasError: false,
      handleChangeCheckbox,
      handleInputChange,
      checked,
      parentCheckboxId,
    };
  }, [
    componentHash,
    handleChangeCheckbox,
    checked,
    handleInputChange,
    inputValues,
    parentCheckboxId,
  ]);

  return uniformInputsData;
};
